import { InstagramLogoIcon, LinkedInLogoIcon } from '@radix-ui/react-icons';
import { Link } from 'react-router-dom';
import { openInExternalUrl } from 'helpers/utils';
import { FacebookIcon, SpotifyIcon, YouTubeIcon } from './SocialIcons';

export const Footer: React.FC = () => (
  <footer className='my-36'>
    <div>
      <div className='flex flex-row justify-center gap-1 text-center md:gap-3'>
        <div
          className='mx-5 cursor-pointer text-accent-accent-9'
          onClick={() => openInExternalUrl('https://www.facebook.com/tennistalker/')}
        >
          <FacebookIcon />
        </div>
        <div
          className='mx-5 cursor-pointer text-accent-accent-9'
          onClick={() => openInExternalUrl('https://www.youtube.com/channel/UCk-SHhxRTu539b0qKuz5WUQ')}
        >
          <YouTubeIcon />
        </div>
        <div
          className='mx-5 cursor-pointer text-accent-accent-9'
          onClick={() => openInExternalUrl('https://open.spotify.com/show/39VEuj1IqIHzzir9Sf8tV0')}
        >
          <SpotifyIcon />
        </div>
        {/* <a
          className='mx-5 text-accent-accent-9 cursor-pointer'
          href='https://twitter.com/tennistalkerweb'
        >
          <TwitterLogoIcon />
        </a> */}
        <div
          className='mx-5 cursor-pointer text-accent-accent-9'
          onClick={() => openInExternalUrl('https://www.instagram.com/tennistalker.it/')}
        >
          <InstagramLogoIcon />
        </div>
        <div
          className='mx-5 cursor-pointer text-accent-accent-9'
          onClick={() => openInExternalUrl('https://www.linkedin.com/company/tennistalker/')}
        >
          <LinkedInLogoIcon />
        </div>
      </div>
      <div className='mt-3 text-center'>
        <div className='flex flex-col justify-center gap-3 text-center md:flex-row'>
          <div className='flex cursor-pointer flex-row justify-center gap-1 md:gap-3'>
            &copy; {new Date().getFullYear()}
            <div
              onClick={() => openInExternalUrl('https://it.linkedin.com/company/tennistalker')}
              title='Tennistalker S.R.L.'
              className='mx-2 text-accent-accent-9'
            >
              Tennistalker S.R.L. Tutti i diritti riservati.
            </div>
          </div>
          <div>
            Contatti:
            <a className='mx-2 text-accent-accent-9' href='mailto:info@tennistalker.it'>
              info@tennistalker.it
            </a>
          </div>
        </div>
        <p className='text-xs'>P. IVA 09787400960 - VIA TINTORETTO, 5 - 20145 MILANO.</p>
        <p className='text-xs'>
          <Link className='mx-2 text-accent-accent-9' to='/condizioni-di-utilizzo'>
            Termini e condizioni
          </Link>
          -
          <Link className='mx-2 text-accent-accent-9' to='/privacy-policy'>
            Privacy policy
          </Link>
          -
          {window?.CookieScript?.instance?.show && (
            <a onClick={window.CookieScript.instance.show} className='mx-2 cursor-pointer text-accent-accent-9'>
              Consent Preferences
            </a>
          )}
        </p>
      </div>
      <br />
    </div>
  </footer>
);

export default Footer;
